import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal, TextField } from "@mui/material";
//*files
import cssClasses from "./AddNote.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";

import { useSelector } from "react-redux";
//service
import { addNote } from "../../Services/LeadNotes";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { Network } from "@capacitor/network";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));
function AddNote({ open, handleClose, returnRes, data }) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [typeList, setTypeList] = useState([
    {
      label: "Claim Follow-up",
      value: "Claim Follow-up",
      isSelected: false,
    },
    {
      label: "Follow-up Feedback",
      value: "Follow-up Feedback",
      isSelected: false,
    },
    {
      label: "Site Visit Follow-up",
      value: "Site Visit Follow-up",
      isSelected: false,
    },
    {
      label: "Token Follow-up",
      value: "Token Follow-up",
      isSelected: false,
    },
    {
      label: "Pending Payments",
      value: "Pending Payments",
      isSelected: false,
    },
    {
      label: "Missing Documents",
      value: "Missing Documents",
      isSelected: false,
    },
    // {
    //   label: "Payment Link",
    //   value: "Payment Link",
    //   isSelected: false,
    // },
    {
      label: "Unit Allotment",
      value: "Unit Allotment",
      isSelected: false,
    },
  ]);
  const [noteType,setNoteType]=useState([
    {
      label: "Call",
      value: "Call",
      isSelected: false,
    },
    {
      label: "Site Visit",
      value: "Site Visit",
      isSelected: false,
    },
    // {
    //   label: "Payment Link Sent",
    //   value: "Payment Link Sent",
    //   isSelected: false,
    // },
  ])
  const [noteData, setNoteData] = useState({
    type: "",//call type
    title: "",
    description: "",
    noteType:""
  });
  const [helperText, setHelperText] = useState({
    type: "",
    title: "",
    noteType:"",
    description: "",
  });
  const classes = useStyles();
  function closeModal() {
    handleClose();
    setHelperText((pre) => {
      pre.title = "";
      pre.description = "";
      pre.type = "";
      return { ...pre };
    });
    setNoteData((pre) => {
      pre.title = "";
      pre.type = "";
      pre.description = "";
      return { ...pre };
    });
  }
  function validate() {
    var form = true;
    if (noteData.type === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.type = "Please select type";
        return { ...preValue };
      });
    }
    if (noteData.noteType === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.noteType = "Please select note type";
        return { ...preValue };
      });
    }
    if (noteData.title === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.title = "Please enter title";
        return { ...preValue };
      });
    }
    if (noteData.description === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.description = "Please enter Description";
        return { ...preValue };
      });
    }

    return {
      flag: form,
    };
  }
  function save() {
    let flag = validate();
    console.log("addNote", data);
    if (flag.flag) {
      Network.getStatus().then((status) => {
        if (status.connected) {
      presentLoader();
      addNote(noteData, loggedInUser.userId, data.leadId)
        .then((resp) => {
          console.log(resp);
          returnRes(true);
          successTost("Note added successfully");
          closeModal();
          dismissLoader();
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
      }else{
        offlineToast();
      }});
    }
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Add Note</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              Select Type <span style={{ color: "red" }}> *</span>
            </div>
            <div style={{ width: "100%" }}>
              <DropDown
                list={typeList}
                selectedValue={noteData.type}
                onChangeSelect={(value) => {
                  setNoteData((pre) => {
                    pre.type = value;
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.type = "";
                    return { ...pre };
                  });
                  typeList.forEach((el, index) => {
                    if (el.value === value) {
                      setTypeList((pre) => {
                        pre[index].isSelected = true;
                        return [...pre];
                      });
                    } else {
                      setTypeList((pre) => {
                        pre[index].isSelected = false;
                        return [...pre];
                      });
                    }
                  });
                }}
                placeHolder={"Select"}
                //style.color is placeHolder's color
                style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                helperText={helperText.type}
              />
            </div>
          </div>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              Select Note Type <span style={{ color: "red" }}> *</span>
            </div>
            <div style={{ width: "100%" }}>
              <DropDown
                list={noteType}
                selectedValue={noteData.noteType}
                onChangeSelect={(value) => {
                  setNoteData((pre) => {
                    pre.noteType = value;
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.noteType = "";
                    return { ...pre };
                  });
                  noteType.forEach((el, index) => {
                    if (el.value === value) {
                      setNoteType((pre) => {
                        pre[index].isSelected = true;
                        return [...pre];
                      });
                    } else {
                      setNoteType((pre) => {
                        pre[index].isSelected = false;
                        return [...pre];
                      });
                    }
                  });
                }}
                placeHolder={"Select Note type"}
                //style.color is placeHolder's color
                style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                helperText={helperText.noteType}
              />
            </div>
          </div>
          <div className={cssClasses.wrapperBlock}>
            <CustomInput
              value={noteData.title}
              label={"Title"}
              mandatory={true}
              handleChange={(newValue) => {
                newValue = newValue.trimStart();
              var alphabet = /^[A-Z*\sa-z*\1-9]*$/;
                if (newValue.match(alphabet) || newValue === "") {
                  if (newValue.length <= 40) {
                    setNoteData((pre) => {
                      pre.title = newValue;
                      return Object.assign({}, pre);
                    });
                    setHelperText((pre) => {
                      pre.title = "";
                      return { ...pre };
                    });
                  }
                }
                if (newValue.length === 0) {
                  setHelperText((pre) => {
                    pre.title = "Please enter title";
                    return { ...pre };
                  });
                }
              }}
              placeholder="Title"
              inputType="label"
              helperText={helperText.title}
              disabled={false}
            />
          </div>
          <div className={cssClasses.wrapperBlock}>
          <div
              className={cssClasses.blockLabel}
              
              style={{
                display: "flex",
                width: "100%",
                 textAlign: "left",
                flexDirection: "column",
                rowGap: "1rem",
              }}
            >
              <span>   Description
              <span style={{ color: "red" }}> *</span></span>
       
             <TextField
              value={noteData.description}
              maxRows={4}
             
              onChange={(e) => {
                e.target.value = e.target.value.trimStart();
                var alphabet = /^[A-Z*\sa-z]*$/;
                //   if (newValue.match(alphabet) || newValue === "") {
                if (e.target.value.length <= 150) {
                  setNoteData((pre) => {
                    pre.description = e.target.value;
                    return Object.assign({}, pre);
                  });
                  setHelperText((pre) => {
                    pre.description = "";
                    return { ...pre };
                  });
                }
                //   }
                if (e.target.value.length === 0) {
                  setHelperText((pre) => {
                    pre.description = "Please enter description";
                    return { ...pre };
                  });
                }
              }}
       
              helperText={helperText.description}
              error={helperText.description !== ""}
              className={classes.TextFieldStyle}
              InputProps={{
                className: classes.inputStyle,
              }}
              inputProps={{ min: 0 }}
              FormHelperTextProps={{ className: classes.helperText }}
              multiline
            />
          </div>
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={() => {
                closeModal();
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Save"}
              clicked={() => {
                save();
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
export default AddNote;
